export enum ResourceCenterEvent {
    FeaturedDownload = 'ResourceCenter.AccessResource',
    CardDownload = 'ResourceCenter.AccessResource',
    MarketoFirstNameAdminCheck = 'ResourceCenter.MarketoFirstNameAdminCheck',
    MarketoLastNameAdminCheck = 'ResourceCenter.MarketoLastNameAdminCheck',
    MarketoEmptyNameCheck = 'ResourceCenter.MarketoEmptyNameCheck',
}
